/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-disable object-curly-spacing */
/* eslint-disable max-len */
/* eslint-disable func-names */
/* global google */

import debounce from 'lodash.debounce';
import MapStyle from './MapStyle';

const closeByMap = document.querySelector( '.closeby-map-google-map' );
const locations = document.querySelectorAll( '.closeby-map-marker' );
const checkboxes = document.querySelectorAll( '.closeby-map-controls-checkboxes input' );

function centerMap( map ) {
  const viewportNudge = window.innerWidth < 782 ? {top: 50, right: 50, bottom: 50, left: 50} : {top: 150, right: 150, bottom: 100, left: 500};
  const bounds = new google.maps.LatLngBounds();

  [...locations].forEach( ( location ) => {
    const latlng = new google.maps.LatLng( parseFloat( location.getAttribute( 'data-lat' ) ), parseFloat( location.getAttribute( 'data-lng' ) ) );
    bounds.extend( latlng );
  } );

  map.setCenter( bounds.getCenter() );
  map.fitBounds( bounds, viewportNudge );
}

function initMap() {
  function ContentOverlay( pos, content, className, map, offsetX, offsetY, color ) {
    this.pos = pos;
    this.content = content;
    this.className = className;
    this.map = map;
    this.div = null;
    this.setMap(map);
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    this.color = color;
  }

  ContentOverlay.prototype = new google.maps.OverlayView();

  ContentOverlay.prototype.onAdd = function () {
    const div = document.createElement( 'div' );
    div.className = this.className;
    div.innerHTML = this.content;
    this.div = div;
    const overlayProjection = this.getProjection();
    const position = overlayProjection.fromLatLngToDivPixel(this.pos);
    const offset = new google.maps.Point(this.offsetX, this.offsetY);
    div.style.left = `${position.x + offset.x} px`;
    div.style.top = `${position.y + offset.y} px`;
    div.style.backgroundColor = this.color;
    const panes = this.getPanes();
    panes.floatPane.appendChild(div);
  };

  ContentOverlay.prototype.draw = function () {
    const overlayProjection = this.getProjection();
    const position = overlayProjection.fromLatLngToDivPixel(this.pos);
    const { div } = this;
    const offset = new google.maps.Point(-`${div.offsetWidth / 2}`, this.offsetY);
    div.style.left = `${position.x + offset.x}px`;
    div.style.top = `${position.y + offset.y}px`;
  };

  ContentOverlay.prototype.onRemove = function () {
    this.div.parentNode.removeChild(this.div);
    this.div = null;
  };

  // ContentOverlay.prototype.hide = function () {
  //   if (this.div) {
  //     this.div.style.visibility = "hidden";
  //   }
  // };

  // ContentOverlay.prototype.show = function () {
  //   if (this.div) {
  //     this.div.style.visibility = "visible";
  //   }
  // };

  // ContentOverlay.prototype.toggle = function () {
  //   if (this.div) {
  //     if (this.div.style.visibility == "hidden") {
  //       this.show();
  //     } else {
  //       this.hide();
  //     }
  //   }
  // };

  // ContentOverlay.prototype.toggleDOM = function () {
  //   if (this.getMap()) {
  //     this.setMap(null);
  //   } else {
  //     this.setMap(this.map);
  //   }
  // };

  const latlng = new google.maps.LatLng(-37.81552, 144.97034);
  const mapOptions = {
    center: latlng,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    styles: MapStyle.greyscale,
    fullscreenControl: false,
    mapTypeControl: false,
  };

  const map = new google.maps.Map( closeByMap, mapOptions );

  [...locations].forEach( ( location ) => {
    const marker = new google.maps.Marker({
      position: new google.maps.LatLng(location.dataset.lat, location.dataset.lng),
      map,
      title: location.dataset.content,
      icon: `data:image/svg+xml,%3Csvg width='30' height='63' viewBox='0 0 30 63' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='15' cy='15' r='15' fill='%23${location.dataset.color.substring(1)}'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M16 33V63H13V33H16Z' fill='black'/%3E%3C/svg%3E%0A`,
    });

    const markerOverlay = new ContentOverlay(
      new google.maps.LatLng(location.dataset.lat, location.dataset.lng),
      `<div>${location.dataset.content}</div>`,
      `closeby-map-title ${location.dataset.category}`,
      map,
      -34,
      -100,
      location.dataset.color,
    );
  } );

  centerMap( map );

  window.addEventListener( 'resize', debounce( () => {
    centerMap( map );
  }, 250 ) );
}

function loadGoogleMap() {
  const script = document.createElement( 'script' );
  script.type = 'text/javascript';
  script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyDkNyji394y7htYmoCgc4hymGKETBomjW0&callback=initMaps';
  document.body.appendChild( script );

  window.initMaps = () => {
    initMap();
  }
}

function toggleOverlays( status, category ) {
  const titles = document.querySelectorAll( `.${category}` );

  titles.forEach( ( title ) => {
    title.hidden = !status;
  } );
}

function initEvents() {
  [...checkboxes].forEach( ( checkbox ) => {
    checkbox.addEventListener( 'change', ( e ) => {
      toggleOverlays( e.target.checked, e.target.dataset.control );
    } );
  } );
}

function init() {
  if ( !closeByMap ) {
    return;
  }
  loadGoogleMap();
  initEvents();
}

export default {
  init,
};
